import Vue from "vue";
import router from "@/router";
import VipDialog from "@/components/VipDialog/VipDialog.vue";

const VipDialogConstructor = Vue.extend(VipDialog);
let instance = null;
let routerHooked = false;
// 仅有this时使用
// this.$vipDialog.open();
// 都可使用
// window.$vipDialog.open();

function getInstance() {
  if (!instance) {
    // 注入全局 router，确保弹窗内可使用 this.$router
    instance = new VipDialogConstructor({ router });
    instance.$mount(document.createElement("div"));
    document.body.appendChild(instance.$el);

    if (!routerHooked) {
      router.beforeEach((to, from, next) => {
        // 路由跳转时隐藏弹窗，但不触发关闭回调
        if (instance && instance.hideForNavigation) {
          instance.hideForNavigation();
        }
        next();
      });

      router.afterEach((to) => {
        // 返回时，如果需要恢复弹窗，则重新显示
        if (instance && instance.restoreIfNeeded) {
          instance.restoreIfNeeded(to);
        }
      });
      routerHooked = true;
    }
  }
  return instance;
}

const vipDialog = {
  /**
   * 打开会员弹窗
   * @param {Object} options
   * @returns {Promise<"confirm"|"close">}
   */
  open(options = {}) {
    const inst = getInstance();
    return inst.open(options);
  },
  close() {
    const inst = getInstance();
    inst.close();
  },
};

export default vipDialog;
